(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-specification-table"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function() {
  var contentContainers = document.querySelectorAll('.specification_table_content');

  contentContainers.forEach(function(content) {
    var maxHeight = 372;
    var isExpanded = false;

    content.style.position = 'relative';

    if (content.offsetHeight > maxHeight) {
      content.style.maxHeight = maxHeight + 'px';

      var maskGradient = document.createElement('div');
      maskGradient.classList.add('mask-gradient');
      content.appendChild(maskGradient); 

      var showMoreButton = document.createElement('button');
      showMoreButton.textContent = 'Show more +';
      showMoreButton.classList.add('semiBold_m');
      showMoreButton.classList.add('specification_table_button');
      content.parentNode.appendChild(showMoreButton);

      showMoreButton.addEventListener('click', function() {
        if (isExpanded) {
          content.style.maxHeight = maxHeight + 'px';
          showMoreButton.textContent = 'Show more  ＋';
          maskGradient.style.display = 'block';
        } else {
          content.style.maxHeight = content.scrollHeight + 'px';
          showMoreButton.textContent = 'Hide  −';
          maskGradient.style.display = 'none'; 
        }
        isExpanded = !isExpanded;
      });
    }
  });
});


  } catch(e) { console.error(e); }
})();
})();
